import { Chat, Prompt } from '../../types';
import { useCallback } from 'react';
import { useCreateChatMutation } from './useCreateChatMutation';
import { ChatType } from '../../dto';
import { useChatContext } from '../chatContext';
import { stringToComplexContent } from '../components/TextMessageInput';
import { getLibraryPromptWizardSteps } from '../../util';
import _ from 'lodash';

export const usePromptClickedCallback = (
  chatType: ChatType,
  chatSubtype: string | null,
  onSuccess?: (chat: Chat) => void
) => {
  const { setChatContext, setCurrentChat, getCurrentModel } = useChatContext();
  const { mutateAsync: createChatMutation } = useCreateChatMutation(
    () => {},
    () => {}
  );

  return useCallback(
    async (prompt: Prompt) => {
      const chat = await createChatMutation({
        firstMessageContent: stringToComplexContent(prompt.title),
        model: getCurrentModel(),
        type: chatType,
        subtype: chatSubtype,
      });
      setChatContext(chat.id, {
        rawContent: '',
        libraryPromptWizardState: {
          steps: getLibraryPromptWizardSteps(prompt),
          currentStepState: {
            index: 0,
            selectedValues: [],
            adhocValues: [],
            addNewMode: false,
            newValueDescription: '',
          },
          prompt: _.cloneDeep(prompt),
        },
      });
      setCurrentChat(chat);
      onSuccess && onSuccess(chat);
      return chat;
    },
    [
      onSuccess,
      createChatMutation,
      setChatContext,
      setCurrentChat,
      getCurrentModel,
      chatType,
      chatSubtype,
    ]
  );
};
